export default __webpack_public_path__ + "static/media/award.40b85676.svg";